(() => {
  function init(host) {
    if (host.dataset.ready) return;
    let pool;
    try { pool = JSON.parse(host.querySelector('[data-trio-data]').textContent).filter(p => p.variants.some(v => v.available)); } catch { return; }
    if (pool.length < 3) return;
    host.dataset.ready = 'true';
    const cards = host.querySelector('[data-trio-cards]'), status = host.querySelector('[data-trio-status]');
    const edit = host.querySelector('[data-trio-edit]'), add = host.querySelector('[data-trio-add]');
    const root = host.dataset.root || '/', seen = new Set();
    const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: host.dataset.currency || 'USD' }).format(value / 100);
    const escape = s => String(s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    let slots = [], busy = false, turn = 0;
    const sizeField = f => /size/i.test(f);
    const variant = slot => slot.p.variants.find(v => v.available && slot.choices.every((c, i) => c !== null && v.options[i] === c));
    const displayVariant = slot => variant(slot) || slot.p.variants.find(v => v.available && slot.choices.every((c,i) => c === null || v.options[i] === c)) || slot.p.variants.find(v => v.available);
    function makeSlot(p, finish) {
      const v = p.variants.find(v => v.available && v.options[0] === finish) || p.variants.find(v => v.id === p.selected && v.available) || p.variants.find(v => v.available);
      return { p, choices: v.options.map((o,i) => sizeField(p.fields[i]) ? null : o) };
    }
    function pick(category, excluded, previous) {
      let candidates = pool.filter(p => p.category === category && !excluded.includes(p.id));
      if (!candidates.length) candidates = pool.filter(p => !excluded.includes(p.id));
      const fresh = candidates.filter(p => !previous.includes(p.id) && !seen.has(p.id));
      const changed = candidates.filter(p => !previous.includes(p.id));
      candidates = fresh.length ? fresh : changed.length ? changed : candidates;
      return candidates[Math.floor(Math.random() * candidates.length)];
    }
    function mix(initial = false) {
      const previous = slots.map(s => s.p.id);
      const patterns = [['rings','earrings','necklaces'],['necklaces','earrings','bracelets'],['rings','bracelets','necklaces']];
      const cats = edit.value === 'mixed' ? patterns[turn++ % patterns.length] : Array(3).fill(edit.value);
      const next = [];
      cats.forEach((cat,i) => {
        const p = initial ? pool.find(p => p.category === cat) : pick(cat, next.map(s => s.p.id), previous);
        next.push(makeSlot(p, 'Gold tone')); seen.add(p.id);
      });
      slots = next; render();
      if (!initial) status.textContent = 'A new combination to make your own. Check your sizes before adding.';
    }
    function fields(slot, n) {
      const v = displayVariant(slot);
      return slot.p.fields.map((field, i) => {
        const label = /color|finish/i.test(field) ? 'Color' : field;
        const values = [...new Set(slot.p.variants.map(v => v.options[i]))].sort((a,b) => a.localeCompare(b,undefined,{numeric:true}));
        if (values.length === 1 && /as shown|default title/i.test(values[0])) return '';
        const options = values.map(value => {
          // Later choices follow earlier fields, so a finish change can unlock its own sizes.
          const available = slot.p.variants.some(v => v.available && v.options[i] === value && slot.choices.slice(0,i).every((c,j) => c === null || v.options[j] === c));
          return `<option value="${escape(value)}" ${slot.choices[i] === value ? 'selected' : ''} ${!available ? 'disabled' : ''}>${escape(value)}${!available ? ' — unavailable' : ''}</option>`;
        }).join('');
        return `<label class="bg-home-option" for="bg-trio-${n}-${i}"><span>${escape(label)}</span><select id="bg-trio-${n}-${i}" data-field="${i}" data-slot="${n}">${sizeField(field) ? `<option value="" ${slot.choices[i] === null ? 'selected' : ''}>Choose size</option>` : ''}${options}</select></label>`;
      }).join('');
    }
    function render() {
      cards.innerHTML = slots.map((slot,n) => {
        const v = displayVariant(slot), url = slot.p.url + '?variant=' + v.id;
        return `<article class="bg-home-trio-card" data-trio-slot="${n}"><div class="bg-home-trio-image"><a href="${escape(url)}" aria-label="View ${escape(slot.p.title)}"><img src="${escape(v.image)}" alt="${escape(slot.p.title)}" width="500" height="550" loading="lazy"></a><span class="bg-home-piece-number">0${n+1}</span><button class="bg-home-swap" type="button" data-swap="${n}" aria-label="Replace ${escape(slot.p.title)}">Swap ↻</button></div><div class="bg-home-trio-card-copy"><div class="bg-home-trio-name"><a href="${escape(url)}">${escape(slot.p.title)}</a><span>${money(v.price)}</span></div><div class="bg-home-options">${fields(slot,n)}</div></div></article>`;
      }).join('');
      updateTotal();
    }
    function updateTotal() {
      const prices = slots.map(s => displayVariant(s).price), total = prices.reduce((a,b) => a+b,0), saving = Math.min(...prices);
      host.querySelector('[data-trio-original]').textContent = money(total);
      host.querySelector('[data-trio-total]').textContent = money(total-saving);
      host.querySelector('[data-trio-saving]').textContent = `Save ${money(saving)}`;
      const ready = slots.length === 3 && slots.every(variant);
      add.disabled = busy || !ready;
      add.textContent = busy ? 'Adding your trio…' : ready ? `Add all 3 to bag — ${money(total-saving)}` : 'Choose your sizes';
    }
    host.addEventListener('change', e => {
      if (e.target === edit) { mix(); return; }
      if (!e.target.matches('[data-field]')) return;
      const n = +e.target.dataset.slot, i = +e.target.dataset.field, slot = slots[n];
      slot.choices[i] = e.target.value || null;
      for (let j = i+1; j < slot.choices.length; j++) {
        const possible = slot.p.variants.filter(v => v.available && slot.choices.slice(0,j).every((c,k) => c === null || v.options[k] === c));
        if (!possible.some(v => v.options[j] === slot.choices[j])) slot.choices[j] = sizeField(slot.p.fields[j]) ? null : possible[0]?.options[j] || null;
      }
      render(); host.querySelector(`#bg-trio-${n}-${i}`)?.focus({preventScroll:true}); status.textContent = '';
    });
    host.addEventListener('click', async e => {
      const button = e.target.closest('button');
      if (!button || busy) return;
      if (button.matches('[data-trio-shuffle]')) { mix(); return; }
      if (button.matches('[data-swap]')) {
        const i = +button.dataset.swap, old = slots[i];
        const p = pick(old.p.category, slots.filter((_,n) => n !== i).map(s => s.p.id), [old.p.id]);
        slots[i] = makeSlot(p, displayVariant(old).options[0]); seen.add(p.id); render();
        host.querySelector(`[data-swap="${i}"]`)?.focus({preventScroll:true}); status.textContent = `Swapped in ${p.title}.`; return;
      }
      if (button !== add || !slots.every(variant)) return;
      busy = true; host.querySelectorAll('button,select').forEach(el => el.disabled = true); updateTotal(); status.textContent = '';
      try {
        const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:slots.map(s => ({id:variant(s).id,quantity:1}))})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'These pieces could not be added. Please check availability and try again.');
        status.textContent = 'Your trio is in your bag. Opening your bag…';
        window.location.assign(root + 'cart');
      } catch (error) {
        status.textContent = error.message || 'Please check your connection and try again.';
        busy = false; host.querySelectorAll('button,select').forEach(el => el.disabled = false); render();
      }
    });
    mix(true);
    host.querySelector('.bg-home-trio-tools').hidden = false;
    host.querySelector('.bg-home-trio-bottom').hidden = false;
    host.querySelector('.bg-home-trio-fallback').hidden = true;
  }
  document.querySelectorAll('[data-bg-home-shop]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-bg-home-shop]').forEach(init));
})();
